const TOKEN_KEYS = ['token', 'accessToken', 'authToken', 'access_token', 'jwt'];

function pickTokenFromObject(obj) {
  if (!obj || typeof obj !== 'object') return null;
  for (let i = 0; i < TOKEN_KEYS.length; i += 1) {
    const k = TOKEN_KEYS[i];
    const v = obj[k];
    if (typeof v === 'string' && v.length > 0) return v;
  }
  return null;
}

/**
 * JWT may live on the response root, under `data`, or on nested `user` objects.
 * User may be flat, under `user`, or under `data` (with token as a sibling of `data`).
 */
export default function extractAuthFromApiBody(apiBody) {
  if (!apiBody || typeof apiBody !== 'object') {
    return { user: null, token: null };
  }

  const token =
    pickTokenFromObject(apiBody) ||
    pickTokenFromObject(apiBody.data) ||
    pickTokenFromObject(apiBody.user) ||
    pickTokenFromObject(apiBody.data?.user);

  let user = null;
  if (apiBody.user && apiBody.user._id) {
    user = apiBody.user;
  } else if (apiBody.data?.user && apiBody.data.user._id) {
    user = apiBody.data.user;
  } else if (
    apiBody.data &&
    typeof apiBody.data === 'object' &&
    !Array.isArray(apiBody.data) &&
    apiBody.data._id
  ) {
    user = apiBody.data;
  } else if (apiBody._id) {
    user = apiBody;
  }

  if (!user) {
    return { user: null, token };
  }

  const userForStore = { ...user };
  TOKEN_KEYS.forEach((k) => {
    delete userForStore[k];
  });
  delete userForStore.password;

  return { user: userForStore, token };
}
